import '../style/main.scss';

import angular from 'angular';
import _ from 'lodash';
import ngAnimate from 'angular-animate';
import ngMessages from 'angular-messages';
import ngCookies from 'angular-cookies';
import ngSanitize from 'angular-sanitize';
import ngMap from 'ngmap';
import ecResource from './helpers/ec-resource';

import {processors} from './processors';
import {models} from './models';
import {controllers} from './controllers';

const ecRomania = angular.module('ec.romania', [
    'ngLocale',
    'ngAnimate',
    'ngMessages',
    'ngCookies',
    'ngSanitize',
    'ngMap',
    'ecResource'
]).constant('DEFAULT_COUNTRY', 'RO');

_.each(processors, (service, name) => {
    ecRomania.factory(name, service);
});

_.each(models, (service, name) => {
    ecRomania.factory(name, service);
});

_.each(controllers, (service, name) => {
    console.log(name, service);
    ecRomania.controller(name, service);
});



// WEBPACK FOOTER //
// ./scripts/main.js